/* VIDEO AUTOPLAY */
document.addEventListener("DOMContentLoaded", () => {
  const videoMediaElements = document.querySelectorAll(".product-gallery video-media");

  videoMediaElements.forEach(vm => {
    // Click play button
    vm.click();

    // Hide native video controls
    const video = vm.querySelector("video");
    if (video) {
      video.controls = false;
    }
  });
});

/* STAMPED IO */
document.addEventListener("theme:loading:end", function () {
  if (window.location.pathname.includes("/collections/")) {
    // Small delay to ensure the DOM has been updated
    setTimeout(function () {
      StampedFn.loadBadges();
    }, 100);
  }
});


/* BACK IN STOCK TRIGGER */
document.addEventListener("DOMContentLoaded", () => {
  // Function to handle back-in-stock trigger
  function handleBackInStockTrigger() {
    const submitButton = document.querySelector('.buy-buttons button[type="submit"]');
    const backInStockElement = document.querySelector('.bis-reset.bis-edge-bottom');

    if (submitButton && backInStockElement) {
      // Remove any existing event listeners to prevent duplicates
      submitButton.removeEventListener('click', handleSubmitButtonClick);

      // Check if the button is disabled (product not available)
      if (submitButton.disabled) {
        submitButton.disabled = false;
        // Add click event listener to the disabled submit button
        submitButton.addEventListener('click', handleSubmitButtonClick);
      }
    }
  }

  // Event handler for submit button click
  function handleSubmitButtonClick(e) {
    e.preventDefault(); // Prevent form submission
    e.stopPropagation(); // Stop event bubbling

    // Trigger click on back-in-stock element
    const backInStockElement = document.querySelector('.bis-reset.bis-edge-bottom');
    if (backInStockElement) {
      backInStockElement.click();
    }
  }

  // Listen for variant changes
  document.addEventListener('variant:change', (event) => {
    const { variant } = event.detail;

    // Check if the variant is not available
    if (variant && !variant.available) {
      // Small delay to ensure the DOM has been updated
      setTimeout(() => {
        handleBackInStockTrigger();
      }, 100);
    } else {
      // If variant is available, remove the event listener
      const submitButton = document.querySelector('.buy-buttons button[type="submit"]');
      if (submitButton) {
        submitButton.removeEventListener('click', handleSubmitButtonClick);
      }
    }
  });

  // Initial check on page load
  handleBackInStockTrigger();
});

/* white buttons */
document.querySelectorAll('.button').forEach(el => {
  if (el.classList.length === 1 && getComputedStyle(el).backgroundColor === 'rgb(255, 255, 255)') {
    el.classList.add('button--white');
  }
});

/* Joutsen country select */
document.querySelectorAll('#joutsen-country-select button').forEach(btn => {
  btn.addEventListener('click', () => {
    const code = btn.dataset.code;
    let url = '';

    if (code === 'FI') url = 'https://www.joutsen.fi';
    else if (code === 'SE') url = 'https://www.joutsen.se';
    else url = 'https://www.joutsen.com';

    window.location.href = url;
  });
});

/* cm to inch converter */
/*
document.querySelectorAll('.js-duvet-size-in').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    // remove active class from all
    document.querySelectorAll('.js-duvet-size-in, .js-duvet-size-cm')
      .forEach(el => el.classList.remove('duvet-selected'));

    // add active class to clicked
    e.currentTarget.classList.add('duvet-selected');

    const cmToInches = 0.3937007874;
    document.querySelectorAll('[data-duvet-size]').forEach(el => {
      const cmText = el.getAttribute('data-duvet-size');
      const [w, h] = cmText.match(/\d+/g).map(Number);
      const inches = `${Math.round(w * cmToInches)}x${Math.round(h * cmToInches)} in`;
      el.innerHTML = `${inches}`;
    });
  });
});
*/

/*
document.querySelectorAll('.duvet-size a').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    // remove active class from all
    document.querySelectorAll('.duvet-size a')
      .forEach(el => el.classList.remove('duvet-selected'));

    // add active class to clicked
    e.currentTarget.classList.add('duvet-selected');

    if(e.currentTarget.classList.contains('js-duvet-size-in')) {
    const cmToInches = 0.3937007874;
    document.querySelectorAll('[data-duvet-size]').forEach(el => {
      const cmText = el.getAttribute('data-duvet-size');
      const [w, h] = cmText.match(/\d+/g).map(Number);
      const inches = `${Math.round(w * cmToInches)}x${Math.round(h * cmToInches)} in`;
      el.innerHTML = `${inches}`;
    });
  } else {
    document.querySelectorAll('[data-duvet-size]').forEach(el => {
      el.innerHTML = el.getAttribute('data-duvet-size');
    });
  }

  });
});
*/



/*
document.body.addEventListener('click', e => {
  const btn = e.target.closest('.duvet-size a');
  if (!btn) return;

  e.preventDefault();

  // remove active class from all
  document.querySelectorAll('.duvet-size a')
    .forEach(el => el.classList.remove('duvet-selected'));

  // add active class to clicked
  btn.classList.add('duvet-selected');

  if (btn.classList.contains('js-duvet-size-in')) {
    const cmToInches = 0.3937007874;
    document.querySelectorAll('[data-duvet-size]').forEach(el => {
      const cmText = el.getAttribute('data-duvet-size');
      const [w, h] = cmText.match(/\d+/g).map(Number);
      const inches = `${Math.round(w * cmToInches)}x${Math.round(h * cmToInches)} in`;
      el.textContent = inches;
    });
  } else {
    document.querySelectorAll('[data-duvet-size]').forEach(el => {
      el.textContent = el.getAttribute('data-duvet-size');
    });
  }
});

document.addEventListener('variant:change', (event) => {
  const { variant, previousVariant } = event.detail;
  const variantPickerElement = document.querySelector('[data-block-id="variant_picker"]');

  const duvet_size_cm = document.querySelector('.js-duvet-size-cm');

  if (duvet_size_cm && duvet_size_cm.classList.contains('duvet-selected')) {
  // Element has the 'duvet-selected' class
  console.log('CM is selected');
} else {
  // It doesn’t have the class
  console.log('CM is not selected');
}

  if (variantPickerElement) {
    // Your custom logic here
    console.log('Variant changed, picker may have been refreshed');
  }
});
*/


/*
// Initialize from localStorage on page load
document.addEventListener('variant:change', () => {
  const savedUnit = localStorage.getItem('duvetUnit') || 'cm';
  const btnSelector = savedUnit === 'in' ? '.js-duvet-size-in' : '.js-duvet-size-cm';
  const btn = document.querySelector(`.duvet-size a${btnSelector ? btnSelector : ''}`);

  if (btn) btn.classList.add('duvet-selected');
  updateDuvetSizes(savedUnit);
});

function updateDuvetSizes(unit) {
  const cmToInches = 0.3937007874;

  document.querySelectorAll('[data-duvet-size]').forEach(el => {
    const cmText = el.getAttribute('data-duvet-size');
    const [w, h] = cmText.match(/\d+/g).map(Number);

    if (unit === 'in') {
      const inches = `${Math.round(w * cmToInches)}x${Math.round(h * cmToInches)} in`;
      el.textContent = inches;
    } else {
      el.textContent = cmText;
    }
  });
}

*/

/*
function setActiveDuvetUnit() {
  const savedUnit = localStorage.getItem('duvetUnit') || 'cm';
  const btnSelector = savedUnit === 'in' ? '.js-duvet-size-in' : '.js-duvet-size-cm';
  const btn = document.querySelector(`.duvet-size a${btnSelector ? btnSelector : ''}`);

  document.querySelectorAll('.duvet-size a').forEach(el => el.classList.remove('duvet-selected'));
  if (btn) btn.classList.add('duvet-selected');

  updateDuvetSizes(savedUnit);
}

function updateDuvetSizes(unit) {
  const cmToInches = 0.3937007874;
  document.querySelectorAll('[data-duvet-size]').forEach(el => {
    const cmText = el.getAttribute('data-duvet-size');
    const [w, h] = cmText.match(/\d+/g).map(Number);
    el.textContent =
      unit === 'in'
        ? `${Math.round(w * cmToInches)}x${Math.round(h * cmToInches)} in`
        : cmText;
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', setActiveDuvetUnit);

// Run after variant change
document.addEventListener('variant:change', setActiveDuvetUnit);



// Click handling
document.body.addEventListener('click', e => {
  const btn = e.target.closest('.duvet-size a');
  if (!btn) return;

  e.preventDefault();

  // remove active class from all
  document.querySelectorAll('.duvet-size a').forEach(el => el.classList.remove('duvet-selected'));
  btn.classList.add('duvet-selected');

  const unit = btn.classList.contains('js-duvet-size-in') ? 'in' : 'cm';
  localStorage.setItem('duvetUnit', unit);

  updateDuvetSizes(unit);
});

*/



/* Duvet dropdown element */


/*
document.body.addEventListener('click', event => {
  const header = event.target.closest('.duvet-dropdown-header');
  if (!header) return;

  header.classList.toggle('duvet-dropdown-header-closed');
  const body = header.nextElementSibling;
  if (body && body.classList.contains('duvet-dropdown-body')) {
    body.classList.toggle('duvet-dropdown-body-closed');
  }
});

document.addEventListener('click', () => {
  const header = document.querySelector('.duvet-dropdown-header');
  const body = document.querySelector('.duvet-dropdown-body');

  if (!header || !body) return;

  if (!header.classList.contains('duvet-dropdown-header-closed')) {
    header.classList.add('duvet-dropdown-header-closed');
    body.classList.add('duvet-dropdown-body-closed');
  }
});
*/

// Helper function to toggle dropdown
function toggleDuvetDropdown(header) {
  if (!header || header.disabled) return;

  const isClosed = header.classList.contains('duvet-dropdown-header-closed');
  const bodyId = header.getAttribute('aria-controls');
  const body = bodyId ? document.getElementById(bodyId) : header.nextElementSibling;

  if (!body) return;

  header.classList.toggle('duvet-dropdown-header-closed');
  body.classList.toggle('duvet-dropdown-body-closed');
  header.setAttribute('aria-expanded', isClosed ? 'true' : 'false');

  // Update tabindex for options when opening/closing
  if (isClosed) {
    // Opening: make first available option focusable
    const options = body.querySelectorAll('.duvet-dropdown-row:not(.is-disabled)');
    options.forEach((option, index) => {
      const label = option;
      label.tabIndex = index === 0 ? 0 : -1;
    });
  } else {
    // Closing: remove focusability from options
    body.querySelectorAll('.duvet-dropdown-row').forEach(option => {
      option.tabIndex = -1;
    });
  }
}

// Helper function to close dropdown
function closeDuvetDropdown(header) {
  if (!header) return;

  const isOpen = !header.classList.contains('duvet-dropdown-header-closed');
  if (!isOpen) return;

  const bodyId = header.getAttribute('aria-controls');
  const body = bodyId ? document.getElementById(bodyId) : header.nextElementSibling;

  if (body) {
    header.classList.add('duvet-dropdown-header-closed');
    body.classList.add('duvet-dropdown-body-closed');
    header.setAttribute('aria-expanded', 'false');

    // Remove focusability from options
    body.querySelectorAll('.duvet-dropdown-row').forEach(option => {
      option.tabIndex = -1;
    });
  }
}

// Click handler for dropdown
document.addEventListener('click', event => {
  const header = event.target.closest('.duvet-dropdown-header');
  const body = event.target.closest('.duvet-dropdown-body');

  if (!body && !header) {
    // Clicked outside → close all open dropdowns
    const openHeaders = document.querySelectorAll('.duvet-dropdown-header:not(.duvet-dropdown-header-closed)');
    openHeaders.forEach(openHeader => closeDuvetDropdown(openHeader));
    return;
  }

  // Clicked on header → toggle dropdown
  if (header) {
    toggleDuvetDropdown(header);
    return;
  }

  // Clicked on option label → select it (radio input will handle the selection)
  const optionRow = event.target.closest('.duvet-dropdown-row');
  if (optionRow && !optionRow.classList.contains('is-disabled')) {
    const input = optionRow.querySelector('input[type="radio"]');
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      // Close dropdown after selection
      const dropdown = optionRow.closest('.duvet-dropdown');
      const header = dropdown?.querySelector('.duvet-dropdown-header');
      if (header) {
        closeDuvetDropdown(header);
        // Use setTimeout to ensure focus happens after variant change is processed
        setTimeout(() => {
          header.focus();
        }, 0);
      }
    }
  }
});

// Keyboard handler for dropdown header
document.addEventListener('keydown', event => {
  const header = event.target.closest('.duvet-dropdown-header');
  if (!header || header.disabled) return;

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    toggleDuvetDropdown(header);

    // If opening, focus first option
    if (!header.classList.contains('duvet-dropdown-header-closed')) {
      const bodyId = header.getAttribute('aria-controls');
      const body = bodyId ? document.getElementById(bodyId) : header.nextElementSibling;
      if (body) {
        const firstOption = body.querySelector('.duvet-dropdown-row:not(.is-disabled)');
        if (firstOption) {
          setTimeout(() => firstOption.focus(), 0);
        }
      }
    }
  }
});

// Keyboard handler for dropdown options
document.addEventListener('keydown', event => {
  const optionRow = event.target.closest('.duvet-dropdown-row');
  if (!optionRow) return;

  const body = optionRow.closest('.duvet-dropdown-body');
  if (!body || body.classList.contains('duvet-dropdown-body-closed')) return;

  const dropdown = body.closest('.duvet-dropdown');
  const header = dropdown?.querySelector('.duvet-dropdown-header');
  const allOptions = Array.from(body.querySelectorAll('.duvet-dropdown-row:not(.is-disabled)'));
  const currentIndex = allOptions.indexOf(optionRow);

  if (event.key === 'ArrowDown') {
    event.preventDefault();
    const nextIndex = (currentIndex + 1) % allOptions.length;
    allOptions[nextIndex].focus();
    allOptions[nextIndex].tabIndex = 0;
    optionRow.tabIndex = -1;
  } else if (event.key === 'ArrowUp') {
    event.preventDefault();
    const prevIndex = currentIndex === 0 ? allOptions.length - 1 : currentIndex - 1;
    allOptions[prevIndex].focus();
    allOptions[prevIndex].tabIndex = 0;
    optionRow.tabIndex = -1;
  } else if (event.key === 'Home') {
    event.preventDefault();
    allOptions[0].focus();
    allOptions.forEach((opt, idx) => { opt.tabIndex = idx === 0 ? 0 : -1; });
  } else if (event.key === 'End') {
    event.preventDefault();
    const lastIndex = allOptions.length - 1;
    allOptions[lastIndex].focus();
    allOptions.forEach((opt, idx) => { opt.tabIndex = idx === lastIndex ? 0 : -1; });
  } else if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    if (!optionRow.classList.contains('is-disabled')) {
      // Dispatch click event on the row to trigger variant change
      optionRow.click();
      if (header) {
        closeDuvetDropdown(header);
        // Use setTimeout to ensure focus happens after click event is processed
        setTimeout(() => {
          header.focus();
        }, 0);
      }
    }
  } else if (event.key === 'Escape') {
    event.preventDefault();
    if (header) {
      closeDuvetDropdown(header);
      header.focus();
    }
  } else if (event.key === 'Tab') {
    // Allow Tab to work normally, but close dropdown if Tab moves focus away
    if (header) {
      setTimeout(() => {
        const activeElement = document.activeElement;
        if (!body.contains(activeElement) && activeElement !== header) {
          closeDuvetDropdown(header);
        }
      }, 0);
    }
  }
});

// Close dropdown when variant changes
document.addEventListener('variant:change', () => {
  const openHeaders = document.querySelectorAll('.duvet-dropdown-header:not(.duvet-dropdown-header-closed)');
  openHeaders.forEach(header => closeDuvetDropdown(header));
});

/* Product card click delegation */
document.body.addEventListener('click', event => {
  // Find the closest product card element
  const productCard = event.target.closest('[data-product-card]');
  if (!productCard) return;

  // Don't delegate if the click happened on an anchor element
  if (event.target.closest('a')) return;

  // Find the product link within the card
  const productLink = productCard.querySelector('[data-product-url]');
  if (!productLink) return;

  const url = productLink.getAttribute('data-product-url');
  if (url) {
    window.location.href = url;
  }
});

/* Collection layout selector keyboard navigation */
document.addEventListener('DOMContentLoaded', () => {
  // Function to update tabindex for all radio buttons in a group
  function updateTabIndexes(radioGroup) {
    const radios = Array.from(document.querySelectorAll(`input[type="radio"][name="${radioGroup}"]`));
    radios.forEach(radio => {
      const label = document.querySelector(`label[for="${radio.id}"]`);
      if (label) {
        // Only unchecked radios are focusable
        label.tabIndex = radio.checked ? -1 : 0;
      }
    });
  }

  // Initialize tabindexes on page load
  updateTabIndexes('mobile-items-per-row');
  updateTabIndexes('desktop-layout');

  // Handle keyboard events on labels
  document.body.addEventListener('keydown', event => {
    const label = event.target.closest('label[for^="mobile-items-per-row"], label[for^="desktop-layout"]');
    if (!label) return;

    // Only handle if label is focusable (unchecked)
    if (label.tabIndex === -1) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      const radioId = label.getAttribute('for');
      const radio = document.getElementById(radioId);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));

        // Update tabindexes after change
        updateTabIndexes(radio.name);
      }
    }
  });

  // Update tabindexes when radio buttons change (handles programmatic changes)
  document.body.addEventListener('change', event => {
    if (event.target.type === 'radio' &&
        (event.target.name === 'mobile-items-per-row' || event.target.name === 'desktop-layout')) {
      updateTabIndexes(event.target.name);
    }
  });
});

/* IMAGE ACCESSIBILITY */
// Function to add aria-hidden to images without aria-label or title
function setImageAriaHidden() {
  const images = document.querySelectorAll('img');

  images.forEach(img => {
    // Check if image has aria-label attribute
    const hasAriaLabel = img.hasAttribute('aria-label') && img.getAttribute('aria-label') !== '';

    // Check if image has title attribute
    const hasTitle = img.hasAttribute('title') && img.getAttribute('title') !== '';

    // If neither aria-label nor title is set, add aria-hidden="true"
    if (!hasAriaLabel && !hasTitle) {
      img.setAttribute('aria-hidden', 'true');
    }
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', setImageAriaHidden);

// Run when theme finishes loading (for dynamic content)
document.addEventListener('theme:loading:end', setImageAriaHidden);

/* CART ACCESSIBILITY - ARIA LIVE REGION */
// Store previous quantities to track changes
const previousQuantities = new Map();

// Function to ensure ARIA live region exists
function ensureAriaLiveRegion() {
  let liveRegion = document.getElementById('cart-aria-live-region');
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'cart-aria-live-region';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'sr-only';
    liveRegion.style.cssText = 'position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border-width: 0;';
    document.body.appendChild(liveRegion);
  }
  return liveRegion;
}

// Function to announce message to screen reader
function announceCartChange(message) {
  const liveRegion = ensureAriaLiveRegion();
  // Clear previous message to ensure new message is announced
  liveRegion.textContent = '';
  // Use setTimeout to ensure the clear happens before setting new content
  setTimeout(() => {
    liveRegion.textContent = message;
    console.log('Announcing: ' + message);
  }, 100);
}

// Initialize ARIA live region on page load
document.addEventListener('DOMContentLoaded', () => {
  ensureAriaLiveRegion();

  // Store initial quantities for all line items
  document.querySelectorAll('line-item').forEach(lineItem => {
    const quantityInput = lineItem.querySelector('input[data-line-key]');
    if (quantityInput) {
      const lineKey = quantityInput.getAttribute('data-line-key');
      const currentQuantity = parseInt(quantityInput.value) || 0;
      previousQuantities.set(lineKey, currentQuantity);
    }
  });
});

// Listen for line-item:will-change to capture previous quantity
document.addEventListener('line-item:will-change', (event) => {
  const { targetQuantity } = event.detail;
  const lineItemElement = event.target.closest('line-item');

  if (!lineItemElement) return;

  const quantityInput = lineItemElement.querySelector('input[data-line-key]');
  if (quantityInput) {
    const lineKey = quantityInput.getAttribute('data-line-key');
    const currentQuantity = parseInt(quantityInput.value) || 0;
    // Store current quantity as previous before change
    previousQuantities.set(lineKey, currentQuantity);
  }
});

// Listen for line item changes (quantity updates and removals)
document.addEventListener('line-item:change', (event) => {
  const { quantity, cart } = event.detail;
  const lineItemElement = event.target.closest('line-item');

  if (!lineItemElement || !cart) return;

  // Get product title from the line item element
  const productTitleElement = lineItemElement.querySelector('.line-item__info a, .line-item__info p.subheading');
  const productTitle = productTitleElement ? productTitleElement.textContent.trim() : 'Item';

  // Get previous quantity from stored map
  const quantityInput = lineItemElement.querySelector('input[data-line-key]');
  const lineKey = quantityInput ? quantityInput.getAttribute('data-line-key') : null;
  const previousQuantity = lineKey ? (previousQuantities.get(lineKey) || 0) : 0;

  let announcement = '';

  if (quantity === 0) {
    // Item was removed
    announcement = `Removed ${productTitle} from cart`;
    // Remove from tracking map
    if (lineKey) {
      previousQuantities.delete(lineKey);
    }
  } else if (previousQuantity > 0 && quantity !== previousQuantity) {
    // Quantity was updated
    announcement = `Updated ${productTitle} quantity to ${quantity} in cart`;
    // Update stored quantity
    if (lineKey) {
      previousQuantities.set(lineKey, quantity);
    }
  } else if (previousQuantity === 0 && quantity > 0) {
    // New item added (shouldn't happen via line-item:change, but handle it)
    announcement = `Added ${productTitle} to cart`;
    if (lineKey) {
      previousQuantities.set(lineKey, quantity);
    }
  }

  if (announcement) {
    // Small delay to ensure DOM has updated
    setTimeout(() => {
      announceCartChange(announcement);
    }, 200);
  }
});

// Listen for cart changes (including item additions)
document.addEventListener('cart:change', (event) => {
  const { baseEvent, cart } = event.detail;

  if (!cart) return;

  // Handle item addition (variant:add event)
  if (baseEvent === 'variant:add') {
    // Get the most recently added item from cart
    const items = cart.items || [];
    if (items.length > 0) {
      const lastItem = items[items.length - 1];
      const productTitle = lastItem.product_title || lastItem.title || 'Item';
      const quantity = lastItem.quantity || 1;

      let announcement = '';
      if (quantity === 1) {
        announcement = `${productTitle} was added to cart`;
      } else {
        announcement = `${quantity} ${productTitle} were added to cart`;
      }

      // Store quantity for new item
      if (lastItem.key) {
        previousQuantities.set(lastItem.key, quantity);
      }

      // Small delay to ensure DOM has updated
      setTimeout(() => {
        announceCartChange(announcement);
      }, 200);
    }
  }

  // Announce cart total when items are added or removed (not just quantity updates)
  if (cart.item_count !== undefined && (baseEvent === 'variant:add' || baseEvent === 'line-item:change')) {
    const itemCount = cart.item_count;
    let countAnnouncement = '';

    // Only announce count for significant changes (additions/removals)
    // Check if this is a removal by comparing item counts
    if (itemCount === 0) {
      countAnnouncement = 'Cart is now empty';
      // Clear all tracked quantities
      previousQuantities.clear();
    }

    if (countAnnouncement) {
      setTimeout(() => {
        announceCartChange(countAnnouncement);
      }, 400);
    }
  }
});

/* PDP image scroller: mobile scrollbar under the gallery */
function bindProductGalleryScrollbar(gallery) {
  const carousel = gallery.querySelector(".product-gallery__carousel");
  const bar = gallery.querySelector("[data-product-gallery-scrollbar]");
  const thumb = bar?.querySelector(".product-gallery__scrollbar-thumb");

  if (!carousel || !bar || !thumb || bar.dataset.bound === "true") {
    return;
  }

  bar.dataset.bound = "true";

  const visibleCells = () => {
    if (carousel.cells?.length) {
      return carousel.cells;
    }

    return [...carousel.children].filter((cell) => !cell.hasAttribute("hidden"));
  };

  const update = () => {
    const cells = visibleCells();
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    if (cells.length < 2 || maxScroll <= 1) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;

    const trackWidth = bar.clientWidth;
    const thumbWidth = trackWidth / cells.length;
    const index = Math.min(
      Math.max(typeof carousel.selectedIndex === "number" ? carousel.selectedIndex : 0, 0),
      cells.length - 1
    );

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translate3d(${index * thumbWidth}px, 0, 0)`;
  };

  const indexFromClientX = (clientX) => {
    const cells = visibleCells();
    const rect = bar.getBoundingClientRect();

    if (!cells.length || rect.width <= 0) {
      return 0;
    }

    const ratio = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 0.9999);
    return Math.min(cells.length - 1, Math.floor(ratio * cells.length));
  };

  bar.addEventListener("pointerdown", (event) => {
    if (event.button !== 0) {
      return;
    }

    bar.setPointerCapture(event.pointerId);

    const onUp = (upEvent) => {
      bar.removeEventListener("pointerup", onUp);
      bar.removeEventListener("pointercancel", onUp);

      const index = indexFromClientX(upEvent.clientX);

      if (typeof carousel.select === "function") {
        carousel.select(index);
        return;
      }

      const cell = visibleCells()[index];
      if (cell) {
        carousel.scrollTo({ left: cell.offsetLeft, behavior: "smooth" });
      }
    };

    bar.addEventListener("pointerup", onUp);
    bar.addEventListener("pointercancel", onUp);
  });

  carousel.addEventListener("carousel:change", update);
  carousel.addEventListener("carousel:settle", update);
  carousel.addEventListener("carousel:filter", () => requestAnimationFrame(update));
  new ResizeObserver(update).observe(carousel);
  new MutationObserver(update).observe(carousel, {
    subtree: true,
    attributes: true,
    attributeFilter: ["hidden"]
  });

  thumb.style.transition = "none";
  update();
  requestAnimationFrame(() => {
    thumb.style.removeProperty("transition");
  });
}

function initProductGalleryScrollbars(root = document) {
  root.querySelectorAll("product-gallery").forEach(bindProductGalleryScrollbar);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initProductGalleryScrollbars());
} else {
  initProductGalleryScrollbars();
}

document.addEventListener("shopify:section:load", (event) => {
  initProductGalleryScrollbars(event.target);
});

// Listen for remove button clicks to provide immediate feedback
document.addEventListener('click', (event) => {
  const removeButton = event.target.closest('.line-item__remove-button, a[href*="cart/change"][href*="quantity=0"]');
  if (removeButton) {
    const lineItemElement = removeButton.closest('line-item');
    if (lineItemElement) {
      const productTitleElement = lineItemElement.querySelector('.line-item__info a, .line-item__info p.subheading');
      const productTitle = productTitleElement ? productTitleElement.textContent.trim() : 'Item';

      // Announce immediately when remove button is clicked
      announceCartChange(`Removing ${productTitle} from cart`);
    }
  }
});

